export default {
  payment: {
    paid: 'Bezahlt',
    unpaid: 'Fehler',
    pending: 'Offen',
    canceled: 'Storniert',
    booked: 'Offen',
    booked_and_paid: 'Bezahlt',
  },

  user: {
    active: 'Aktiv',
    pending: 'Offen',
    suspended: 'Pausiert',
    deactivated: 'Inaktiv',
    pre_registered: 'Vorregistriert',
    pre_registered_planned: 'Geplant',
    pre_activated: 'Voraktiviert',
    declined: 'Abgelehnt',
  },

  license: {
    generated: 'Generated',
    confirmed: 'Confirmed',
    canceled: 'Fehler',
    activated: 'Aktiv',
    expired: 'Expired',
  },

  organisation: {
    business: 'Business',
    enterprise: 'Business Pro',
    individual: 'Privat',
    grunder_service: 'Grunder service',
  },
}
